import type { ComparisonFeature } from './search-novelty-result-api.ts';

export interface NoveltyFeatureComparisonRequest {
    task_id: string;
    patent_pns: string[];
    operate_type?: string;
    text?: string;
}

export interface NoveltyFeatureComparisonResponse {
    final_res: {
        patent_id: string;
        features: ComparisonFeature[];
        public_score: number;
        document: string;
        lang: string;
        comparativeLiteratureType?: 'X' | 'Y' | 'A';
        comparison_conclusion: {
            en: string;
            zh: string;
        };
    }[];
    threshold: number;
}

export interface FtoReportFeatureComparisonApi {
    /**
     * 获取技术特征对比得分
     * @param data
     * @returns
     */
    getFeatureComparison: (data: NoveltyFeatureComparisonRequest) => Promise<NoveltyFeatureComparisonResponse>;
}

export const FtoReportFeatureComparisonApi = Symbol('FtoReportFeatureComparisonApi');
